var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper"},[_c('card',{staticClass:"card-centered"},[_c('p',[_c('img',{attrs:{"src":"/img/cyto-logo.png"}})]),_c('p',[_vm._v("You are being logged out...")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }